/**
 * Subscription Upsell Popup
 * Intercepts /cart/add.js fetch calls while the Einzelkauf pane is active.
 * Skip  → lets the original one-time add proceed.
 * Add   → drops the one-time add, adds the subscription version instead.
 */
(function () {
  'use strict';

  // Only activate on pages that have the Einzelkauf pane
  if (!document.getElementById('pdp-pane-onetime') && document.readyState !== 'loading') {
    if (!document.getElementById('pdp-pane-onetime')) return;
  }

  var SHOPIFY_ROOT = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var originalFetch = window.fetch;

  /* ── Pending fetch state ── */
  var pendingArgs = null;
  var pendingCallbacks = null;
  var pendingVariantId = null;
  var pendingQty = 1;

  /* ── Helpers ── */
  function getOverlay() {
    return document.getElementById('SubPopupOverlay');
  }

  function isEinzelkaufActive() {
    var pane = document.getElementById('pdp-pane-onetime');
    return !!(pane && pane.classList.contains('active'));
  }

  /* ── Popup open / close ── */
  function showPopup() {
    var el = getOverlay();
    if (!el) return;
    el.style.display = '';
    void el.offsetHeight;
    el.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    var el = getOverlay();
    if (!el) return;
    el.classList.remove('is-active');
    document.body.style.overflow = '';
    setTimeout(function () { el.style.display = 'none'; }, 300);
  }

  /* ── Reset any loading state on the native ATC button ── */
  function resetNativeAtcState() {
    var nativeAtc = document.querySelector('.m-add-to-cart[name="add"]');
    if (nativeAtc) {
      nativeAtc.disabled = false;
      nativeAtc.classList.remove('is-loading', 'loading', 'btn--loading');
    }
  }

  /* ── Populate selling plans from the Spar-Abo select ── */
  function populatePopupPlans() {
    var src = document.querySelector('.pdp-frequency-select');
    var dest = document.querySelector('[data-sub-popup-interval]');
    if (!src || !dest) return;
    var opts = src.querySelectorAll('option');
    if (!opts.length) return;
    dest.innerHTML = '';
    opts.forEach(function (o) {
      if (!o.value) return;
      var opt = document.createElement('option');
      opt.value = o.value;
      opt.textContent = o.textContent.trim();
      dest.appendChild(opt);
    });
  }

  /* ── Cancel: close popup + reset all pending state + restore native button ── */
  function cancelPopup() {
    closePopup();
    resetNativeAtcState();
    pendingArgs = null;
    if (pendingCallbacks) {
      pendingCallbacks.resolve(new Response('{"items":[]}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
      pendingCallbacks = null;
    }
  }

  /* ── Skip: let the original one-time fetch proceed ── */
  function proceedWithOnetimeAdd() {
    if (pendingCallbacks && pendingArgs) {
      var args = pendingArgs;
      var callbacks = pendingCallbacks;
      pendingArgs = null;
      pendingCallbacks = null;
      closePopup();
      originalFetch.apply(window, args)
        .then(callbacks.resolve)
        .catch(callbacks.reject);
    } else {
      closePopup();
    }
  }

  /* ── Open the Minimog cart drawer ── */
  function openCartDrawer() {
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
      drawer.onCartDrawerUpdate();
    }
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
    originalFetch(SHOPIFY_ROOT + 'cart.json')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (drawer && typeof drawer.updateCartCount === 'function') {
          drawer.updateCartCount(cart.item_count);
        }
        if (window.MinimogEvents && window.MinimogTheme) {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, cart);
          MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
        }
      });
  }

  /* ── Add subscription instead ── */
  function addSubscriptionToCart(btn) {
    var intervalSelect = document.querySelector('[data-sub-popup-interval]');
    var sellingPlanId = intervalSelect ? intervalSelect.value : '';
    var variantId = (btn && btn.getAttribute('data-variant-id')) || pendingVariantId;

    if (!variantId || !sellingPlanId) {
      populatePopupPlans();
      var retrySelect = document.querySelector('[data-sub-popup-interval]');
      sellingPlanId = retrySelect ? retrySelect.value : '';
      if (!variantId || !sellingPlanId) {
        proceedWithOnetimeAdd();
        return;
      }
    }

    // Resolve the pending one-time fetch with a fake empty response to unblock the theme
    pendingArgs = null;
    if (pendingCallbacks) {
      pendingCallbacks.resolve(new Response('{"items":[]}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
      pendingCallbacks = null;
    }

    btn.disabled = true;

    originalFetch(SHOPIFY_ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: pendingQty || 1, selling_plan: parseInt(sellingPlanId, 10) }] }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        closePopup();
        resetNativeAtcState();
        openCartDrawer();
      })
      .catch(function () {
        closePopup();
        resetNativeAtcState();
      })
      .finally(function () { btn.disabled = false; });
  }

  /* ── Intercept fetch ── */
  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && typeof args[0] === 'object' && args[0].url) || '';

    if (url.indexOf('cart/add') !== -1 && isEinzelkaufActive()) {
      // Skip interception for internal free gift adds
      try {
        var parsedBody = JSON.parse(args[1] && args[1].body);
        if (parsedBody && parsedBody.items && parsedBody.items[0] && parsedBody.items[0].properties && parsedBody.items[0].properties._free_gift) {
          return originalFetch.apply(window, args);
        }
      } catch (e) {}

      // Extract variant + qty from request body
      try {
        var body = JSON.parse(args[1] && args[1].body);
        if (body && body.id) pendingVariantId = String(body.id);
        if (body && body.quantity) pendingQty = body.quantity;
        if (body && body.items && body.items[0]) {
          if (body.items[0].id) pendingVariantId = String(body.items[0].id);
          if (body.items[0].quantity) pendingQty = body.items[0].quantity;
        }
      } catch (e) {}

      var addBtn = document.querySelector('[data-sub-popup-add]');
      if (addBtn && pendingVariantId) addBtn.setAttribute('data-variant-id', pendingVariantId);

      pendingArgs = args;
      populatePopupPlans();

      return new Promise(function (resolve, reject) {
        pendingCallbacks = { resolve: resolve, reject: reject };
        showPopup();
      });
    }

    return originalFetch.apply(window, args);
  };

  /* ── Event listeners ── */
  function init() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sub-popup-close]')) { e.preventDefault(); cancelPopup(); }
    });

    document.addEventListener('click', function (e) {
      if (e.target.id === 'SubPopupOverlay') cancelPopup();
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sub-popup-skip]')) { e.preventDefault(); proceedWithOnetimeAdd(); }
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sub-popup-add]');
      if (btn) { e.preventDefault(); addSubscriptionToCart(btn); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var el = getOverlay();
        if (el && el.classList.contains('is-active')) closePopup();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
